import { useShippingService } from '../service/check-shipping-price';

export function UseShipping() {
  const { shippingPrice, ...restOrderService } = useShippingService();

  async function checkShippingPrice(payload: CalculateParcelPricePayload) {
    const response = await shippingPrice(payload);
    return response;
  }

  return {
    checkShippingPrice,
    ...restOrderService,
  };
}

export default UseShipping;
